import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import { nameFirme, kindName, statusName, payName } from "@/helpers/reference";

const state = {
  operators: [],
  operatorsLoading: false,
  freePacks: {
    data: []
  },
  assignedPacks: {
    data: []
  },
  packsCountband: {
    data: []
  },
  packsQuantity: {
    data: []
  },
  statusLinkPack: null,
  statusInfoPack: null
};

const mutations = {
  setOperators: (state, payload) => (state.operators = payload),
  setOperatorsLoading: (state, payload) => (state.operatorsLoading = payload),
  setFreePacks: (state, payload) => (state.freePacks = payload),
  clearFreePacks: state => (state.freePacks = { data: [] }),
  setAssignedPacks: (state, payload) => (state.assignedPacks = payload),
  clearAssignedPacks: state => (state.assignedPacks = { data: [] }),
  setPacksCountband: (state, payload) => (state.packsCountband = payload),
  clearPacksCountband: state => (state.packsCountband = { data: [] }),
  setPacksQuantity: (state, payload) => (state.packsQuantity = payload),
  clearPacksQuantity: state => (state.packsQuantity = { data: [] }),
  setStatusLinkPack: (state, payload) => (state.statusLinkPack = payload),
  clearStatusLinkPack: state => (state.statusLinkPack = null),
  setStatusInfoPack: (state, payload) => (state.statusInfoPack = payload),
  clearStatusInfoPack: state => (state.statusInfoPack = null)
};

const actions = {
  async getOperators(
    { commit, rootState },
    { workedEnabled, workedDate, positionEnabled, positionCode }
  ) {
    try {
      commit("setOperatorsLoading", true);
      let params = {
        script: "web.wbusersfromoper",
        funcname: "wbRunSelect"
      };
      if (workedEnabled) {
        params["datstaff"] = workedDate;
      }
      if (positionEnabled) {
        params["codepost"] = positionCode === null ? "null" : positionCode;
      }

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setOperators", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setOperatorsLoading", false);
    }
  },
  async getFreePacks({ commit, rootState }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbnotassignmentpack",
            funcname: "wbRunSelect"
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setFreePacks", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getAssignedPacks({ commit, rootState }, { puserid }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbassignmentpack",
            funcname: "wbRunSelect",
            puserid: `${puserid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setAssignedPacks", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async assignPack({ commit, rootState }, { npack, userid }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbnazn",
            funcname: "wbrunnazn",
            npack: `${npack}`,
            userid: `${userid}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusLinkPack", userid);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async unassignPack({ commit, rootState }, { npack, userid }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbosvobod",
            funcname: "wbrunsvobod",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusLinkPack", userid);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPacksCountband({ commit, rootState }, { npack }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbband",
            funcname: "wbRunSelect",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPacksCountband", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async getPacksQuantity({ commit, rootState }, { npack, nband }) {
    try {
      commit("setLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbkvit",
            funcname: "wbRunSelect",
            npack: `${npack}`,
            nband: `${nband}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPacksQuantity", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setLoading", false);
    }
  },
  async receiptsInfoPack({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);
      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznos",
            funcname: "wbraznoska",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setStatusInfoPack", npack);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  operators: state => state.operators,
  operatorsLoading: state => state.operatorsLoading,
  freePacks: (state, rootState) => {
    let items = [];
    state.freePacks.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["statusname"] = statusName(item.status);
      items.push(item);
    });
    return items;
  },
  assignedPacks: (state, rootState) => {
    let items = [];
    state.assignedPacks.data.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["statusname"] = statusName(item.status);
      items.push(item);
    });
    return items;
  },
  packsCountband: state => state.packsCountband.data,
  packsQuantity: (state, rootState) => {
    let items = [];
    state.packsQuantity.data.forEach(item => {
      item["nameplat"] = payName(rootState.params.codepay.data, item.codeplat);
      items.push(item);
    });
    return items;
  },
  statusLinkPack: state => state.statusLinkPack,
  statusInfoPack: state => state.statusInfoPack
};

export default { state, mutations, actions, getters };
